import AntdInput from 'antd/es/input';
import Input from './Input';

const instence: typeof AntdInput = Object.assign({}, Input, AntdInput);
export default instence;
